import { redirect, type RedirectReason } from '../../core/api/redirect';
import { ApiSource, Brand } from '../../core/context/claims';
import './BackLink.css';
import { useAppContext } from '../../core/context';
import { useApi } from '../../platform/api/useApi';
import { useNavigation } from '../../platform/navigation/useNavigation';
import { useIframe } from '../../platform/iframe/useIframe';
import { useDevice } from '../../platform/device/useDevice';
import PrimaryButton from '../PrimaryButton/PrimaryButton';

interface BackLinkProps {
  children?: React.ReactNode;
  reason: RedirectReason;
}

function BackLink({ children, reason }: BackLinkProps): React.ReactNode {
  const context = useAppContext();
  const apis = useApi();
  const navigation = useNavigation();
  const iframe = useIframe();
  const device = useDevice();
  const claims = context?.claims;
  const onClick = async () => {
    await apis.cancel(context);
    redirect(
      claims?.fallback,
      reason,
      claims?.brand ?? Brand.MOBILEPAY,
      claims?.apiSource ?? ApiSource.EPayment,
      device.isMobile,
      navigation,
      iframe
    );
  };
  return <PrimaryButton onClick={onClick}>{children}</PrimaryButton>;
}

export default BackLink;
